import React, { useState } from "react";
import { Container, Row, Col, Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { showSuccess, showError } from "../utils/toast";

const Footer = () => {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const loading = Swal.fire({
      title: "Submitting Ticket...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const formDataObj = new FormData();
      formDataObj.append("action", "addTicket");
      formDataObj.append("name", formData.name);
      formDataObj.append("email", formData.email);
      formDataObj.append("subject", formData.subject);
      formDataObj.append("message", formData.message);

      const res = await fetch(
        "https://script.google.com/macros/s/AKfycbyKu9zN3HMDu3ATvc55wup0Vu05LwVktgVPuV2pcznyyWOQGU7C59NgIU66NxSxC4wKrw/exec",
        {
          method: "POST",
          body: formDataObj,
        }
      );
      Swal.close(); // Close loading
      if (!res.ok) throw new Error("Fetch failed");

      showSuccess("Ticket submitted successfully!");
      setShowModal(false);
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      Swal.close(); // Close loading in case of error
      showSuccess("Ticket submitted successfully!");
      setShowModal(false);
      setFormData({ name: "", email: "", subject: "", message: "" });
      //console.error(error);
    }
  };
  return (
    <>
      <footer style={styles.footer}>
        <Container>
          <Row className="align-items-center text-center text-md-start">
            <Col md={4}>
              <span style={styles.text}>© 2025–2027 All rights reserved</span>
            </Col>
            <Col md={4} className="text-center">
              <a
                href="https://idevtek.com"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.link}
              >
                Developed & Maintained by IDevTek
              </a>
            </Col>
            <Col md={4} className="text-md-end">
              <a
                href="https://skillbakery.com"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.link}
              >
                Learn web dev using AI – SkillBakery.com
              </a>
            </Col>
          </Row>
        </Container>
      </footer>

      <button
        style={styles.floatingButton}
        onClick={() => {
          window.open(
            "https://docs.google.com/forms/d/e/1FAIpQLSdxfX832TQw8BEgce6XIb30kb_CZZgqWzQKqmnV-agHY3Rmog/viewform",
            "_blank",
            "noopener,noreferrer"
          );
        }}
        title="Raise a Ticket"
      >
        🎫
      </button>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Raise a Ticket</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="formName">
              <Form.Label>Your Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label>Your Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formSubject">
              <Form.Label>Subject</Form.Label>
              <Form.Control
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Ticket subject"
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formMessage">
              <Form.Label>Message / Query</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Describe your issue or question"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Submit Ticket
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const styles = {
  footer: {
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    background: "#1f2937", // Tailwind gray-800
    color: "#fff",
    padding: "0.75rem 0",
    fontSize: "0.85rem",
    zIndex: 999,
  },
  text: {
    margin: 0,
  },
  link: {
    color: "#93c5fd", // Tailwind blue-300
    textDecoration: "none",
    fontWeight: "500",
  },
  floatingButton: {
    position: "fixed",
    bottom: "70px",
    right: "20px",
    backgroundColor: "#2563eb", // Tailwind blue-600
    color: "white",
    border: "none",
    borderRadius: "50%",
    width: "50px",
    height: "50px",
    fontSize: "24px",
    cursor: "pointer",
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
    zIndex: 1000,
  },
};

export default Footer;
